import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"facebook\"><path d=\"M378 272h-90v240h-93V272h-64v-86h64v-74C195 54 234 0 320 0c35 0 61 3 61 3l-3 80h-55c-32 0-35 16-35 39v60h93z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook.svg
// module id = 193
// module chunks = 0